import { render, staticRenderFns } from "./PackagingRequirements.vue?vue&type=template&id=057b0cd9&scoped=true"
import script from "./PackagingRequirements.vue?vue&type=script&lang=js"
export * from "./PackagingRequirements.vue?vue&type=script&lang=js"
import style0 from "./PackagingRequirements.vue?vue&type=style&index=0&id=057b0cd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b0cd9",
  null
  
)

export default component.exports